import { useState, useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { authAPI } from '../api/auth';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);
  const hasChecked = useRef(false);

  useEffect(() => {
    // Prevent multiple simultaneous auth checks
    if (hasChecked.current) return;
    hasChecked.current = true;

    // Check authentication by calling /auth/me
    // HTTP-only cookie is sent automatically
    authAPI.getMe()
      .then(() => {
        setIsAuthenticated(true);
      })
      .catch((error) => {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
